<template>
	<v-container fluid>
		<dashboard-gaming-component
			:idCliccatore="null"
		></dashboard-gaming-component>
	</v-container>
</template>

<script>
import mixin from '../../mixins';
export default {

}
</script>

